// Heading copy for the Goals advice step. Like the SSI/retirement-age steps the
// heading is returned as `{ text, bold }` segments so the total can be rendered
// in bold within the otherwise-regular sentence.

import { numberToDollars } from '../../../../utils'

const t = text => ({ text })
const amount = value => ({ text: value, bold: true })

/**
 * Returns the heading segments for the Goals step.
 *
 * @param {number} includedCount number of included (non-past) goals
 * @param {number} total combined amount still needed across the included goals
 * @returns {Array<{ text: string, bold?: boolean }>}
 */
export function getHeadingSegments({ includedCount, total }) {
  const dollars = `$${numberToDollars(total, true)}`

  // One included goal, even if there are also excluded goals listed.
  if (includedCount === 1) {
    return [
      t('Besides retirement, you have 1 other goal that needs a total of '),
      amount(dollars),
      t('.'),
    ]
  }

  return [
    t(`Besides retirement, you have ${includedCount} other goals that need a total of `),
    amount(dollars),
    t('.'),
  ]
}
